import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { useSelector } from 'react-redux';
import { DealershipAddnewPopup } from './DealershipAddnewPopup';
import Theme from '../ui/Theme';
import AddNewTag from './AddNewTag';
import CustomIconButton from '../shared/CustomIconButton';
import CustomButton from '../shared/CustomButton';

const useStyles = makeStyles((theme) => ({
  imgStyles: {
    width: '475px',
    height: '300px',
  },
  addressHeading: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: 0,
  },
  tagBtnStyle: {
    height: '35px',
    width: '100%',
    margin: '0px 10px 10px 0px',
    backgroundColor: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
  },
  addTagBtnStyle: {
    height: '35px',
    background: Theme.palette.secondary.main,
    width: '100%',
    marginBottom: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',

    textAlign: 'center',
    letterSpacing: '0.2px',

    color: Theme.palette.quad.main,
  },
  addressText: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: 'black',
    marginTop: '5px',
  },
  container: {
    overflow: 'auto',
    width: '281px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  editStyle: {
    fontWeight: 400,
    fontSize: '14px',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
  },
  editButton: {
    height: '35px',
    marginRight: '10px',
  },
  editDiv: {
    marginTop: '20px',
  },
}));

const LeftBar = ({ customStyles }) => {
  const classes = useStyles();
  const dealershipDetails = useSelector((state) => state.DealershipDetails.dealershipdetails);
  const [isAddnewPopupOpen, setisAddnewPopupOpen] = React.useState(false);
  const [openAddTag, setOpenAddTag] = React.useState(false);
  const closeAddNewDealership = () => {
    setisAddnewPopupOpen(false);
  };
  const openAddTagPopup = () => {
    setOpenAddTag(true);
  };
  const handleCloseAddNewTag = () => {
    setOpenAddTag(false);
  };

  return (
    <>
      <section className={customStyles}>
        <Grid
          className={classes.container}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item>
            <p className={classes.addressHeading}>
              {dealershipDetails.domainList?.length > 1 ? 'DOMAIN NAME LIST' : 'DOMAIN NAME'}
            </p>
            <p className={classes.addressText}>{dealershipDetails.domainList?.join(', ')}</p>
          </Grid>
          {dealershipDetails.primaryContactName && (
            <Grid item>
              <p className={classes.addressHeading}>PRIMARY CONTACT PERSON</p>
              <p className={classes.addressText}>{dealershipDetails.primaryContactName}</p>
            </Grid>
          )}
          {dealershipDetails.primaryContactNumber && (
            <Grid item>
              <p className={classes.addressHeading}>PRIMARY CONTACT NUMBER</p>
              <p className={classes.addressText}>{dealershipDetails.primaryContactNumber}</p>
            </Grid>
          )}
          <Grid item>
            <p className={classes.addressHeading}>PRIMARY CONTACT EMAIL</p>
            <p className={classes.addressText}>{dealershipDetails.primaryContactEmail}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>Plans</p>
            <p className={classes.addressText}>
              {dealershipDetails.plans ? dealershipDetails.plans.map((item) => item.title).toString() : ''}
            </p>
          </Grid>
          {dealershipDetails.parentDealership?.name ? (
            <Grid item>
              <p className={classes.addressHeading}>PARENT</p>
              <p className={classes.addressText}>{dealershipDetails.parentDealership?.name}</p>
            </Grid>
          ) : null}
          <Grid item>
            <p className={classes.addressHeading}>HUBSPOT ID</p>
            <p className={classes.addressText}>{dealershipDetails.hubspotId}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>TIMEZONE</p>
            <p className={classes.addressText}>{dealershipDetails.timezone}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>SALES PIPELINE STATUS</p>
            <p className={classes.addressText}>{dealershipDetails?.leadPipelineStatus?.title || '-'}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>PX OWNER</p>
            <p className={classes.addressText}>{dealershipDetails?.pxOwnerName || '-'}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>STATUS</p>
            <p className={classes.addressText}>{dealershipDetails.enabled ? 'Enabled' : 'Disabled'}</p>
          </Grid>
          <Grid container>
            <p className={classes.addressHeading}>Dealership Tags</p>
            <Grid item xs={12}>
              <Grid container direction="row">
                {dealershipDetails?.tags?.map((data) => (
                  <Grid item style={{ margin: '0px 10px 10px 0px' }}>
                    <CustomButton type="secondary" label={data?.title} size="small" clickable={false} />
                  </Grid>
                ))}
                <Grid item>
                  <CustomIconButton
                    color="primary"
                    size="small"
                    icon={<AddIcon />}
                    onClick={openAddTagPopup}
                    label="Add Dealership Tag"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section>
      <div className={classes.editDiv}>
        <Button
          variant="contained"
          color="primary"
          focusRipple={false}
          onClick={() => {
            setisAddnewPopupOpen(!isAddnewPopupOpen);
          }}
          className={classes.editButton}
        >
          Edit
        </Button>
      </div>
      {isAddnewPopupOpen && (
        <DealershipAddnewPopup open={isAddnewPopupOpen} close={closeAddNewDealership} add={false} />
      )}
      {openAddTag && <AddNewTag open type="dealership" close={handleCloseAddNewTag} />}
    </>
  );
};

export default LeftBar;
